export default ({request}) =>({
    materialCategoryTreeApi(data = {}){
        return request({
            url: '/master/material/category/select/material/tree',
            method:'post',
            data,
        })
    },
    //物料公共组件树形下拉api
    materialCategoryListTreeApi(data = {}){
        return request({
            url: '/master/material/category/select/material/list/tree',
            method:'post',
            data,
        })
    },
    materialCategoryListApi(data = {}){
        return request({
            url: '/master/material/category/list',
            method:'post',
            data,
        })
    },
    materialCategorySaveApi(data = {}){
        return request({
            url: '/master/material/category/save',
            method:'post',
            data,
        })
    },
    materialCategoryDetailApi(data = {}){
        return request({
            url: '/master/material/category/detail',
            method:'post',
            data,
        })
    },
    materialCategoryDelApi(data = {}) {
        return request({
          url: '/master/material/category/del',
          method: 'post',
          data,
        })
    },
    materialCategoryTreeV1Api(data = {}){
        return request({
            url: '/master/material/category/tree',
            method:'post',
            data,
        })
    },
})